var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lv > 4)?_c('img',{staticClass:"lv",attrs:{"src":_vm.lv === 7 ? 
      (_vm.BaseUrl + "assets/label_diamond.png") : (_vm.lv === 6 ? 
        (_vm.BaseUrl + "assets/label_platinum.png") : 
        (_vm.BaseUrl + "assets/label_gold.png")),"srcset":_vm.lv === 7 ? 
      (_vm.BaseUrl + "assets/label_diamond@2x.png") : (_vm.lv === 6 ? 
        (_vm.BaseUrl + "assets/label_platinum@2x.png") : 
        (_vm.BaseUrl + "assets/label_gold@2x.png")),"width":_vm.size}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }